import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { TERMLIST, AGELIST, PAYMENDEADLINE, SEXLIST, SOCIALSECURITYIST } from './utils';
import { attachDetail, attachPlanDetail, addAttachPlan, editAttachPlan } from './../request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    topTitle
  },
  data() {
    return {
      TERMLIST,
      AGELIST,
      PAYMENDEADLINE,
      SEXLIST,
      SOCIALSECURITYIST,
      dialogVisible: false,
      dataFrom: {
        attachId: '',
        name: '',
        code: '',
        price: '',
        amount: '',
        duration: {
          type: 1,
          value: ''
        },
        age: {
          type: 3,
          value: ''
        },
        paymentDeadline: {
          way: undefined,
          type: 1,
          value: ''
        },
        sex: 0,
        socialSecurity: 0,
        insuranceTermsId: ''
      },
      duration1: '',
      duration2: '',
      age1: '',
      age2: '',
      rightsList: [{
        name: '',
        value: '',
        info: ''
      }],
      termsList: [],
      termsId: undefined,
      termsShow: false,
      tagList: [],
      continueState: false,
      saveLoading: false,
      type: '',
      isRights: true
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: false,
          max: 20,
          message: this.$t('最多输入') + '20' + this.$t('字符'),
          trigger: 'blur'
        }],
        code: [{
          required: false,
          max: 20,
          message: this.$t('最多输入') + '20' + this.$t('字符'),
          trigger: 'blur'
        }, {
          min: 4,
          message: this.$t('至少输入') + '4' + this.$t('字符'),
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          trigger: 'blur',
          validator: this.validateAmount
        }],
        price: [{
          required: true,
          trigger: 'blur',
          validator: this.validatePrice
        }],
        duration: [{
          required: true,
          validator: this.validateDuration
        }],
        age: [{
          required: true,
          validator: this.validateAge
        }],
        paymentDeadline: [{
          required: true,
          validator: this.validateDeadline,
          trigger: 'change'
        }],
        rights: [{
          required: true,
          trigger: 'change',
          validator: this.validateRights
        }],
        insuranceTermsId: [{
          required: true,
          trigger: 'change',
          validator: this.validateInsuranceTermsId
        }],
        remark: [{
          required: false,
          max: 50,
          message: this.$t('最多输入') + '50' + this.$t('字符'),
          trigger: 'blur'
        }],
        unit: [{
          required: false,
          max: 10,
          message: this.$t('最多输入') + '10' + this.$t('字符'),
          trigger: 'blur'
        }],
        occupation: [{
          required: false,
          trigger: 'blur',
          validator: this.validateOccupation
        }]
      };
    }
  },
  methods: {
    validateDuration(rule, value, callback) {
      console.log(this.duration1);
      if (this.dataFrom.duration.type != 5) {
        if (!this.duration1) {
          callback(new Error(this.$t('请完善保障期限,仅限输入0以上数字')));
        } else if (this.duration1 > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else if (this.dataFrom.duration.type == 2 || this.dataFrom.duration.type == 4) {
          if (this.duration2 == '') {
            callback(new Error(this.$t('请完善保障期限,仅限输入0以上数字')));
          } else if (this.duration2 > 40000000) {
            callback(new Error(this.$t('第二个数值不能大于40000000')));
          } else if (this.duration1 >= this.duration2) {
            callback(new Error(this.$t('第一个数值应小于第二个数值')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
      callback();
    },
    validateAge(rule, value, callback) {
      console.log(this.age1);
      if (!this.age1 && this.age1 != 0) {
        callback(new Error(this.$t('请完善保障年龄,仅限输入数字')));
      } else if (this.age1 > 40000000) {
        callback(new Error(this.$t('不能大于40000000')));
      } else if (this.dataFrom.age.type < 6) {
        if (!this.age2) {
          callback(new Error(this.$t('请完善保障年龄,仅限输入0以上数字')));
        } else if (this.age2 > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else if (this.age1 >= this.age2 && this.dataFrom.age.type != 4 && this.dataFrom.age.type != 5) {
          callback(new Error(this.$t('第一个数值应小于第二个数值')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validateDeadline(rule, value, callback) {
      if (this.dataFrom.paymentDeadline.way == 1) {
        if (this.dataFrom.paymentDeadline.value <= 0 || this.dataFrom.paymentDeadline.value > 99) {
          callback(new Error(this.$t('请填写1-99范围内数字')));
        } else {
          callback();
        }
      } else if (this.dataFrom.paymentDeadline.way == 0) {
        callback();
      } else if (this.dataFrom.paymentDeadline.way == undefined) {
        callback(new Error(this.$t('请选择') + this.$t('缴费期限')));
      }
    },
    validateRights(rule, value, callback) {
      let arr = [];
      this.isRights = true;
      this.rightsList.map(item => {
        // if (item.name && item.value > 0 && String(item.value).charAt(0) != '.') {
        //   if (String(item.value).indexOf('.') > -1) {
        //     if (String(value).split('.')[1].length < 3 && Number(value) < 40000000) {
        //       arr.push(item);
        //     }
        //   } else if (Number(item.value) < 40000000) {
        //     console.log(444);
        //     arr.push(item);
        //   }
        // }
        if (item.name && item.value) {
          arr.push(item);
        }
      });
      if (arr.length == 0 || arr.length != this.rightsList.length) {
        this.isRights = false;
        callback(
        // new Error(this.$t('请完善保障权益,其中保障金额仅限输入0以上到40000000的数字、小数点;小数点不能为第一位'))
        new Error(this.$t('请完善保障权益')));
      } else {
        callback();
      }
    },
    validateInsuranceTermsId(rule, value, callback) {
      if (this.termsList.length != 0) {
        if (this.tagList.length == 0) {
          callback(new Error(this.$t('请选择条款文件')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validatePrice(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('保费,仅限输入0以上数字、小数点')));
      } else if (Number(value) < 0) {
        callback(new Error(this.$t('仅限输入0以上数字、小数点')));
      } else if (String(value).charAt(0) == '.') {
        callback(new Error(this.$t('小数点不能为第一位')));
      } else if (String(value).indexOf('.') > -1) {
        if (String(value).split('.').length != 2) {
          callback(new Error(this.$t('只能拥有一个小数点')));
        } else if (String(value).split('.')[1].length > 2) {
          callback(new Error(this.$t('小数点之后保留两位')));
        } else if (String(value).split('.')[1].length == 0) {
          callback(new Error(this.$t('小数点之后必须有一位')));
        } else if (Number(value) > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      } else if (Number(value) > 40000000) {
        callback(new Error(this.$t('不能大于40000000')));
      } else {
        callback();
      }
    },
    validateAmount(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('保障金额,仅限输入0以上数字、小数点')));
      } else if (Number(value) < 0) {
        callback(new Error(this.$t('仅限输入0以上数字、小数点')));
      } else if (String(value).charAt(0) == '.') {
        callback(new Error(this.$t('小数点不能为第一位')));
      } else if (String(value).indexOf('.') > -1) {
        if (String(value).split('.').length != 2) {
          callback(new Error(this.$t('只能拥有一个小数点')));
        } else if (String(value).split('.')[1].length > 2) {
          callback(new Error(this.$t('小数点之后保留两位')));
        } else if (String(value).split('.')[1].length == 0) {
          callback(new Error(this.$t('小数点之后必须有一位')));
        } else if (Number(value) > 40000000) {
          callback(new Error(this.$t('不能大于40000000')));
        } else {
          callback();
        }
      } else if (Number(value) > 40000000) {
        callback(new Error(this.$t('不能大于40000000')));
      } else {
        callback();
      }
    },
    validateOccupation(rule, value, callback) {
      if (!value) {
        callback();
      } else if (value.indexOf(',') == -1) {
        callback(new Error(this.$t('格式不对,例:1至N类，输入格式为1,n;N类，输入格式为n,n')));
      } else {
        const arr = value.split(',');
        if (arr.length != 2) {
          callback(new Error(this.$t('格式不对,例:1至N类，输入格式为1,n;N类，输入格式为n,n')));
        } else if (/[^1-9]/g.test(arr[0])) {
          callback(new Error(this.$t('第一个值应该是数值')));
        } else if (/[^1-9]/g.test(arr[1])) {
          callback(new Error(this.$t('第二个值应该是数值')));
        } else {
          callback();
        }
      }
    },
    async init(attachId, val, type) {
      this.type = type;
      const {
        termsList
      } = await attachDetail({
        insuranceAttachId: attachId
      });
      if (termsList.length != 0) {
        this.termsList = recursionCopy(termsList);
        this.termsList.unshift({
          id: -1,
          name: this.$t('全部')
        });
      }
      this.termsShow = termsList.length == 0 ? false : true;
      if (!val) {
        this.termsId = -1;
        if (this.termsShow) {
          this.checked = false;
          this.tagList = recursionCopy(termsList);
        }
        this.dataFrom = {
          attachId: '',
          name: '',
          code: '',
          duration: {
            type: 1,
            value: ''
          },
          age: {
            type: 3,
            value: ''
          },
          paymentDeadline: {
            way: undefined,
            type: 1,
            value: ''
          },
          sex: 0,
          socialSecurity: 0,
          insuranceTermsId: '',
          price: '',
          amount: ''
        };
      } else {
        const res = await attachPlanDetail({
          insuranceAttachPlanId: val.id
        });
        this.dataFrom = res;
        this.rightsList = res.rights;
        this.checked = res.generalTerms;
        if (res.duration.type == 2 || res.duration.type == 4) {
          this.duration1 = res.duration.value[0];
          this.duration2 = res.duration.value[1];
        } else if (res.duration.type == 5) {
          this.duration1 = '';
        } else {
          this.duration1 = res.duration.value[0];
        }
        if (res.age.type < 6) {
          this.age1 = Number(res.age.value[0]);
          this.age2 = Number(res.age.value[1]);
        } else {
          this.age1 = Number(res.age.value);
        }
        if (res.paymentDeadline.way == 0) {
          this.dataFrom.paymentDeadline.type = 1;
          this.dataFrom.paymentDeadline.value = '';
        }
        this.tagList = res.termsList;
        // if (res.insuranceTermsId) {
        //   this.tagList = await insuranceTermsResource({insuranceTermsId: res.insuranceTermsId});
        // }
        if (this.tagList.length == this.termsList.length - 1) {
          this.termsId = -1;
        } else {
          this.termsId = undefined;
        }
        if (type == 'copy') {
          this.dataFrom.name = '';
          this.dataFrom.code = '';
          delete this.dataFrom.insuranceAttachPlanId;
        }
      }
      this.dataFrom.attachId = attachId;
      this.dialogVisible = true;
    },
    onPaymentDeadlineChange() {
      this.dataFrom.paymentDeadline.value = '';
      console.log(this.dataFrom.paymentDeadline);
      this.$refs.paymentDeadline.onFieldChange();
    },
    onPaymentDeadlineInput() {
      this.$refs.paymentDeadline.onFieldChange();
    },
    onAgeInput() {
      this.$refs.age.onFieldChange();
    },
    onDurationInput() {
      this.$refs.duration.onFieldChange();
    },
    addRightsFun() {
      this.$refs.rights.onFieldChange();
      this.$nextTick(() => {
        console.log(this.$refs.rights.onFieldChange());
        if (this.isRights) {
          this.rightsList.push({
            name: '',
            value: '',
            info: ''
          });
        }
      });
    },
    delRightsFun(index) {
      this.rightsList.splice(index, 1);
      this.$refs.rights.onFieldChange();
    },
    durationChange(type) {
      this[type] = this[type].replace(/[^\d]/g, '');
    },
    termsChange(val) {
      if (val == -1) {
        this.termsList.map(item => {
          if (item.id != -1) {
            const obj = this.tagList.find(item2 => item2.id == item.id);
            if (!obj) {
              this.tagList.push(recursionCopy(item));
            }
          }
        });
      } else if (val) {
        const obj = this.termsList.find(item => item.id == val);
        const obj2 = this.tagList.find(item => item.id == val);
        console.log(obj);
        if (obj && !obj2) {
          this.tagList.push(recursionCopy(obj));
        }
      }
      this.checkAllFun();
    },
    handleTagClose(removedTag) {
      const tags = this.tagList.filter(tag => tag.id !== removedTag.id);
      console.log(tags);
      this.tagList = tags;
      this.checkAllFun();
    },
    checkAllFun() {
      if (this.tagList.length == this.termsList.length - 1) {
        this.termsId = -1;
      } else {
        this.termsId = undefined;
      }
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        console.log(55, valid);
        if (valid) {
          this.saveLoading = true;
          if (this.dataFrom.duration.type != 5) {
            this.dataFrom.duration.value = String(this.duration1);
            if (this.dataFrom.duration.type == 2 || this.dataFrom.duration.type == 4) {
              this.dataFrom.duration.value = this.duration1 + ',' + this.duration2;
            }
          }
          this.dataFrom.age.value = String(this.age1);
          if (this.dataFrom.age.type < 6) {
            this.dataFrom.age.value = this.age1 + ',' + this.age2;
          }
          this.dataFrom.rights = this.rightsList;
          if (this.termsList.length == 0) {
            this.dataFrom.generalTerms = 'false';
            this.dataFrom.insuranceTermsId = '';
          } else {
            if (this.tagList.length == this.termsList.length - 1) {
              this.dataFrom.generalTerms = 'true';
              this.dataFrom.insuranceTermsId = '';
            } else {
              this.dataFrom.generalTerms = 'false';
              if (this.tagList.length != 0) {
                const arr = this.tagList.map(item => {
                  return item.id;
                });
                this.dataFrom.insuranceTermsId = arr.join(',');
              }
            }
          }
          console.log(this.dataFrom);
          const FUN = this.dataFrom.insuranceAttachPlanId ? editAttachPlan : addAttachPlan;
          FUN(recursionCopy(this.dataFrom)).then(res => {
            console.log(res);
            this.saveLoading = false;
            if (res.code != 200) {
              return this.$message.error(this.$t(res.message));
            }
            this.$message.success(this.$t('操作成功') + '!');
            this.$emit('ok');
            if (this.continueState) {
              this.$refs.dataFrom.resetFields();
              this.init(this.dataFrom.attachId, false, 'add');
              this.duration1 = '';
              this.duration2 = '';
              this.age1 = '';
              this.age2 = '';
              this.rightsList = [{
                name: '',
                value: '',
                info: ''
              }];
              this.dataFrom = {
                attachId: '',
                name: '',
                code: '',
                duration: {
                  type: 1,
                  value: ''
                },
                age: {
                  type: 3,
                  value: ''
                },
                paymentDeadline: {
                  way: undefined,
                  type: 1,
                  value: ''
                },
                sex: 0,
                socialSecurity: 0,
                insuranceTermsId: ''
              };
            } else {
              this.$emit('cancel');
            }
          });
        }
      });
    },
    priceChange(type) {
      console.log(type, this.dataFrom[type]);
      this.dataFrom[type] = String(this.dataFrom[type]).replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.');
      console.log(this.dataFrom[type].replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.'));
    }
  }
};